/**
 * @fileoverview gRPC-Web generated client stub for dash.v1
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v1.5.0
// 	protoc              v0.0.0
// source: dash/v1/exam_group.proto


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');


var dash_v1_models_pb = require('../../dash/v1/models_pb.js')

var types_v1_status_pb = require('../../types/v1/status_pb.js')
const proto = {};
proto.dash = {};
proto.dash.v1 = require('./exam_group_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.dash.v1.ExamGroupServiceClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.dash.v1.ExamGroupServicePromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.dash.v1.GetExamGroupRequest,
 *   !proto.dash.v1.GetExamGroupResponse>}
 */
const methodDescriptor_ExamGroupService_GetExamGroup = new grpc.web.MethodDescriptor(
  '/dash.v1.ExamGroupService/GetExamGroup',
  grpc.web.MethodType.UNARY,
  proto.dash.v1.GetExamGroupRequest,
  proto.dash.v1.GetExamGroupResponse,
  /**
   * @param {!proto.dash.v1.GetExamGroupRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.dash.v1.GetExamGroupResponse.deserializeBinary
);


/**
 * @param {!proto.dash.v1.GetExamGroupRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.dash.v1.GetExamGroupResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.dash.v1.GetExamGroupResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.dash.v1.ExamGroupServiceClient.prototype.getExamGroup =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/dash.v1.ExamGroupService/GetExamGroup',
      request,
      metadata || {},
      methodDescriptor_ExamGroupService_GetExamGroup,
      callback);
};


/**
 * @param {!proto.dash.v1.GetExamGroupRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.dash.v1.GetExamGroupResponse>}
 *     Promise that resolves to the response
 */
proto.dash.v1.ExamGroupServicePromiseClient.prototype.getExamGroup =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/dash.v1.ExamGroupService/GetExamGroup',
      request,
      metadata || {},
      methodDescriptor_ExamGroupService_GetExamGroup);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.dash.v1.PutExamGroupRequest,
 *   !proto.dash.v1.PutExamGroupResponse>}
 */
const methodDescriptor_ExamGroupService_PutExamGroup = new grpc.web.MethodDescriptor(
  '/dash.v1.ExamGroupService/PutExamGroup',
  grpc.web.MethodType.UNARY,
  proto.dash.v1.PutExamGroupRequest,
  proto.dash.v1.PutExamGroupResponse,
  /**
   * @param {!proto.dash.v1.PutExamGroupRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.dash.v1.PutExamGroupResponse.deserializeBinary
);


/**
 * @param {!proto.dash.v1.PutExamGroupRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.dash.v1.PutExamGroupResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.dash.v1.PutExamGroupResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.dash.v1.ExamGroupServiceClient.prototype.putExamGroup =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/dash.v1.ExamGroupService/PutExamGroup',
      request,
      metadata || {},
      methodDescriptor_ExamGroupService_PutExamGroup,
      callback);
};


/**
 * @param {!proto.dash.v1.PutExamGroupRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.dash.v1.PutExamGroupResponse>}
 *     Promise that resolves to the response
 */
proto.dash.v1.ExamGroupServicePromiseClient.prototype.putExamGroup =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/dash.v1.ExamGroupService/PutExamGroup',
      request,
      metadata || {},
      methodDescriptor_ExamGroupService_PutExamGroup);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.dash.v1.ListExamGroupsRequest,
 *   !proto.dash.v1.ListExamGroupsResponse>}
 */
const methodDescriptor_ExamGroupService_ListExamGroups = new grpc.web.MethodDescriptor(
  '/dash.v1.ExamGroupService/ListExamGroups',
  grpc.web.MethodType.UNARY,
  proto.dash.v1.ListExamGroupsRequest,
  proto.dash.v1.ListExamGroupsResponse,
  /**
   * @param {!proto.dash.v1.ListExamGroupsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.dash.v1.ListExamGroupsResponse.deserializeBinary
);


/**
 * @param {!proto.dash.v1.ListExamGroupsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.dash.v1.ListExamGroupsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.dash.v1.ListExamGroupsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.dash.v1.ExamGroupServiceClient.prototype.listExamGroups =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/dash.v1.ExamGroupService/ListExamGroups',
      request,
      metadata || {},
      methodDescriptor_ExamGroupService_ListExamGroups,
      callback);
};


/**
 * @param {!proto.dash.v1.ListExamGroupsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.dash.v1.ListExamGroupsResponse>}
 *     Promise that resolves to the response
 */
proto.dash.v1.ExamGroupServicePromiseClient.prototype.listExamGroups =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/dash.v1.ExamGroupService/ListExamGroups',
      request,
      metadata || {},
      methodDescriptor_ExamGroupService_ListExamGroups);
};


module.exports = proto.dash.v1;

